import { createContext } from 'react';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import type { SerializedError } from '@reduxjs/toolkit';

export type Severity = 'success' | 'error' | 'warning' | 'info';

export type NotificationContent =
  string | string[] | React.ReactNode | { title: React.ReactNode; subtitle?: React.ReactNode };

export interface NotificationContextType {
  showNotification: (message: NotificationContent, severity: Severity) => void;
  showSuccessNotification: (message: NotificationContent) => void;
  showErrorNotification: (err: string | string[] | FetchBaseQueryError | SerializedError) => void;
  showInfoNotification: (message: string | string[]) => void;
  hideNotification: () => void;
}

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined);
